import React, { FC } from 'react';
import styles from './lawyer_picture_components.module.scss';

export const LawyerPictureEmpty: FC = () => (
  <div
    className={`${styles.picture} ${styles.empty}`}
    style={{ backgroundImage: 'url(/img/user/lawyer_icon.png)' }}
  />
);

export const LawyerPicture: FC<{ lawyerImg: string }> = ({ lawyerImg }) => (
  <div
    className={styles.picture}
    style={{ backgroundImage: `url(${lawyerImg})` }}
  />
);
